import { DateUtil, isNullOrUndefined } from '@uzurv/core';
import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';
import { AbstractApproval } from './abstract-approval';
import { ApprovalActivity } from './approval-activity';

@inheritSerialization(AbstractApproval)
export class ApprovalObjectInfo extends AbstractApproval {
  @autoserialize
  object: string;

  @autoserialize
  status: string;

  @autoserialize
  requestorNote: string;

  @autoserializeAs(ApprovalActivity)
  approvalActivity: Array<ApprovalActivity>;

  getEffectiveDate(): Date {
    if (!isNullOrUndefined(this.object['effectiveDate'])) {
      return DateUtil.deserializeInstant(this.object['effectiveDate']);
    }
  }
}
